import React from "react";

type Tone = "blue" | "purple" | "gray";

const TONE_CLASSES: Record<Tone, string> = {
  blue: "text-blue-700 bg-blue-100",
  purple: "text-purple-700 bg-purple-100",
  gray: "text-gray-700 bg-gray-200",
};

const TONE_HINTS: Record<Tone, string> = {
  blue: "All accounts in the system",
  purple: "Users with admin privileges",
  gray: "Accounts that cannot log in",
};

interface Props {
  label: string;
  value: number;
  tone: Tone;
}

const StatCard: React.FC<Props> = ({ label, value, tone }) => (
  <div className="flex items-center gap-4 p-4 bg-white border border-gray-200 rounded-lg shadow-sm">
    <div
      className={`flex items-center justify-center w-10 h-10 text-lg font-semibold rounded-full ${TONE_CLASSES[tone]}`}
    >
      {value}
    </div>
    <div>
      <div className="text-sm font-medium text-gray-900">{label}</div>
      <div className="text-xs text-gray-500">{TONE_HINTS[tone]}</div>
    </div>
  </div>
);

export default StatCard;
